import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-mx-auto long-input" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { computed, ref, withDefaults } from "vue";
import { ProjectIdentifierProps } from "@/types";
import { createProjectApiStore, identifierSaveStore } from "@/hooks";
import { SwitchInput, TextButton } from "@/components/common";
import ProjectFilesInput from "./ProjectFilesInput.vue";
import ProjectIdentifierInput from "./ProjectIdentifierInput.vue";


/**
 * Creates projects with bulk uploaded files.
 */
const __default__ = {
  name: "ProjectFilesUploader",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dataCyName: { default: "input-project-name" },
    dataCyDescription: { default: "input-project-description" }
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedFiles = ref<File[]>([]);
const emptyFiles = ref(false);
const summarize = ref(false);

const identifier = computed(() => identifierSaveStore.editedIdentifier);
const isUpdate = computed(() => identifierSaveStore.isUpdate);

const disabled = computed(() => {
  const isNameInvalid = identifier.value.name.length === 0;

  if (emptyFiles.value) {
    return isNameInvalid;
  } else {
    return (
      isNameInvalid ||
      (selectedFiles.value.length === 0 && !emptyFiles.value) ||
      !selectedFiles.value.find(({ name }) => name === "tim.json")
    );
  }
});

/**
 * Attempts to save the project.
 */
async function handleCreate() {
  await createProjectApiStore.handleBulkImport(
    identifier.value,
    selectedFiles.value,
    summarize.value,
    {
      onSuccess: () => {
        selectedFiles.value = [];
        identifierSaveStore.resetIdentifier(true);
        emit("submit");
      },
    }
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProjectIdentifierInput, {
      name: identifier.value.name,
      "onUpdate:name": _cache[0] || (_cache[0] = ($event: any) => ((identifier.value.name) = $event)),
      description: identifier.value.description,
      "onUpdate:description": _cache[1] || (_cache[1] = ($event: any) => ((identifier.value.description) = $event)),
      "is-update": isUpdate.value,
      "data-cy-name": props.dataCyName,
      "data-cy-description": props.dataCyDescription
    }, null, 8, ["name", "description", "is-update", "data-cy-name", "data-cy-description"]),
    _createElementVNode("div", _hoisted_1, [
      (!emptyFiles.value)
        ? (_openBlock(), _createBlock(ProjectFilesInput, {
            key: 0,
            modelValue: selectedFiles.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedFiles).value = $event)),
            "data-cy": "input-files-bulk"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(SwitchInput), {
        modelValue: emptyFiles.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emptyFiles).value = $event)),
        label: "Create an empty project",
        "data-cy": "toggle-create-empty-project"
      }, null, 8, ["modelValue"]),
      _hoisted_2,
      _createVNode(_unref(SwitchInput), {
        modelValue: summarize.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((summarize).value = $event)),
        label: "Generate artifact summaries",
        "data-cy": "toggle-create-summarize"
      }, null, 8, ["modelValue"]),
      _createVNode(_unref(TextButton), {
        block: "",
        label: "Create Project From Files",
        color: "primary",
        disabled: disabled.value,
        loading: _unref(createProjectApiStore).loading,
        class: "q-mt-md",
        "data-cy": "button-create-project",
        onClick: handleCreate
      }, null, 8, ["disabled", "loading"])
    ])
  ]))
}
}

})